import { atom, selector } from 'recoil'
import { IAccessRole } from '../types/types'
import { fetchAccessRoles } from '../hooks/use-fetch-access-roles'

const accessRoleDefaultState = selector({
  key: 'accessRoleDefaultState',
  get: async () => {
    try {
      return await fetchAccessRoles()
    } catch (e) {
      return []
    }
  },
})

export const accessRolesState = atom<IAccessRole[]>({
  key: 'accessRolesState',
  default: accessRoleDefaultState,
})